query GetEventQuestionTemplates {
  eventQuestionTemplates {
    id
    key
    label
    questionType
    options
    sfField
  }
}
